<mat-spinner [mode]="mode" [value]="value" [color]="'primary'"></mat-spinner>
<br>
<div class="precentage-container">
    <h1>{{value}}%</h1>

</div>